import { render } from "./Textcampaign.vue?vue&type=template&id=612e2b30"
import script from "./Textcampaign.vue?vue&type=script&lang=js"
export * from "./Textcampaign.vue?vue&type=script&lang=js"

import "./Textcampaign.vue?vue&type=style&index=0&id=612e2b30&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__